import { Component, Inject } from '@angular/core';
import {
  MatDialog,
  MAT_DIALOG_DATA, 
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose
} from '@angular/material/dialog';
import { DialogData } from '../purchaseorder-delete-modal/purchaseorder-delete-modal.component';
import {MatButtonModule} from '@angular/material/button';
import {FormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { CabinetService } from 'src/app/home/services/cabinet.service';

@Component({
  selector: 'app-cabinet-list-modal',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    CommonModule
  ],
  templateUrl: './cabinet-list-modal.component.html',
  styleUrls: ['./cabinet-list-modal.component.scss', '../../app.component.scss']
})
export class CabinetListModalComponent {

  public cabinet = {
    cabinet_id: "",
    type: "",
    name: "",
    minimum_quantity: "",
  };
  public isCabinet: boolean = true;
  public errorMessage: string = "";
 
  constructor(
    public dialogRef: MatDialogRef<CabinetListModalComponent>,
    public cabinetService: CabinetService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if(data){
      this.cabinet.cabinet_id = data.cabinet_id;
      this.cabinet.type = data.type;
      this.cabinet.name = data.name;
    }
  } 

  editCabinet(formData: any){
      this.cabinetService.editCabinet(this.cabinet.cabinet_id, formData).subscribe({
        next: (res) => {
          if (res.data) {
            this.dialogRef.close(res.data.u_name);
          }
        },
        error: (err) => {
          if (this.cabinet.type === 'u_name') {
            this.errorMessage = "The given cabinet name has already been taken.";
          }else{
            this.errorMessage = "The given minimum order quantity is invalid. Try to give minimum 25";
          }
        },
        complete: () => console.info('complete') 
      });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
